// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1B9wC","container":"styles_container__M2Lgg","title":"styles_title__3oV0-","wrapper":"styles_wrapper__10Y_a","answer":"styles_answer__R7JOZ"};